import { FC } from 'react';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { ElementsButton } from '../Button';
import { Icon, getFileIconNameByExtension } from '../Icon';
import { File as GQLFile } from '../../../generated/graphql';

export interface UnsupportedDocumentPaneProps {
  file: Pick<GQLFile, 'name' | 'createdAt' | 'createdBy'>;
  downloadURL?: string;
  /** When provided, this pane is showing a render failure (rather than a genuinely unsupported file type), so also offer a retry. */
  onRetry?: () => void;
}

export const UnsupportedDocumentPane: FC<UnsupportedDocumentPaneProps> = ({ file, downloadURL, onRetry }) => {
  const { t: tFile } = useTranslation('file');

  return (
    <div className="flex max-w-md flex-col items-center gap-4 text-center">
      <Icon icon={getFileIconNameByExtension(file.name.split('.').pop() ?? '')} className="h-16 w-16" />
      <div>
        <p className="truncate text-lg font-normal text-white">{file.name}</p>
        <p className="text-sm font-normal text-darkMode-gray-light">
          <span className="text-darkMode-gray-light/70">{tFile('date-added-file-label')} </span>
          {format(new Date(file.createdAt), 'MMM d, yyyy')} {tFile('added-by-file-label')} {file.createdBy.givenName}{' '}
          {file.createdBy.familyName}
        </p>
      </div>
      <p className="text-darkMode-gray-light">{tFile('document-viewer-unsupported-file-type')}</p>
      <div className="flex gap-3">
        {onRetry && <ElementsButton label={tFile('document-viewer-retry')} theme="secondary" onClick={onRetry} />}
        <ElementsButton
          label={tFile('document-viewer-open-in-new-tab')}
          theme="secondary"
          disabled={!downloadURL}
          onClick={() => downloadURL && window.open(downloadURL, '_blank', 'noopener,noreferrer')}
        />
      </div>
    </div>
  );
};
